"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class Card extends React.Component {
    render() {
        const { link, icon, title, text, openInNewTab } = this.props;
        return (React.createElement("a", { href: link, target: openInNewTab ? "_blank" : "", className: "QuickLinksCard" },
            React.createElement("img", { className: "icon", src: icon }),
            React.createElement("h3", null, title),
            text &&
                React.createElement("div", { className: "text" }, text)));
    }
}
exports.Card = Card;
exports.default = Card;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-quick-links-card/Card.tsx